module.exports = __webpack_public_path__ + "static/media/VerifiedIcon.4a343b23.svg";